import React from 'react';
import styled from 'styled-components';
import { device } from '../../styles/devices';

const StyledEditIcon = styled.svg`
  width: 16px;
  height: 16px;
  @media ${device.tablet} {
    width: 24px;
    height: 24px;
  }
`;

const EditIcon: React.FC = () => {
  return (
    <StyledEditIcon
      width="16"
      height="16"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8,4.2 L18.4,7.3 L15.8,12.8 M5.5,17.8 L9.1,19.5 M5.5,17.8 L5.5,22.5 L9.1,19.5 L16.6,3.5 C16.8,3.2 16.6,2.8 16.3,2.6 L13.9,1.5 C13.6,1.3 13.2,1.5 13,1.8 L5.5,17.8 Z"
        stroke="currentColor"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        aria-label="edit-icon"
      />
    </StyledEditIcon>
  );
};

export default EditIcon;
